// This file is auto-generated by scripts/generate-models.ts
// Do not edit manually - run 'npm run generate-models' to update

import type { Model } from "../types.ts";

export const DEEPSEEK_MODELS = {
	"deepseek-v4-flash": {
		id: "deepseek-v4-flash",
		name: "DeepSeek V4 Flash",
		api: "openai-completions",
		provider: "deepseek",
		baseUrl: "https://api.deepseek.com",
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"requiresReasoningContentOnAssistantMessages":true,"thinkingFormat":"deepseek"},
		reasoning: true,
		thinkingLevelMap: {"minimal":null,"low":null,"medium":null,"high":"high","max":"max"},
		input: ["text"],
		cost: {
			input: 0.14,
			output: 0.28,
			cacheRead: 0.0028,
			cacheWrite: 0,
		},
		contextWindow: 1000000,
		maxTokens: 384000,
	} satisfies Model<"openai-completions">,
	"deepseek-v4-pro": {
		id: "deepseek-v4-pro",
		name: "DeepSeek V4 Pro",
		api: "openai-completions",
		provider: "deepseek",
		baseUrl: "https://api.deepseek.com",
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"requiresReasoningContentOnAssistantMessages":true,"thinkingFormat":"deepseek"},
		reasoning: true,
		thinkingLevelMap: {"minimal":null,"low":null,"medium":null,"high":"high","max":"max"},
		input: ["text"],
		cost: {
			input: 0.435,
			output: 0.87,
			cacheRead: 0.003625,
			cacheWrite: 0,
		},
		contextWindow: 1000000,
		maxTokens: 384000,
	} satisfies Model<"openai-completions">,
} as const;
